import { _breakP } from './utils.js';
export default class tab {
  constructor() {
    this.generalTabFunc();
  }

  generalTabFunc() {
    const $tabBlock = document.querySelectorAll('.js-tab');

    if ($tabBlock.length) {
      $tabBlock.forEach((blockElm, blockIdx) => {
        const $tabBtn = blockElm.querySelectorAll('.js-tabBtn'),
          $tabBtnParent = blockElm.querySelectorAll('.js-tabBtnWrap'),
          $tabItemParent = blockElm.querySelectorAll('.js-tabContWrap'),
          $tabItem = blockElm.querySelectorAll('.js-tabCont');

        $tabItemParent.forEach(contElm => {
          const $targetCont = contElm.querySelectorAll('.js-tabCont');
          for (let i = 0; i < $targetCont.length; i++) {
            $targetCont[i].setAttribute('id', `panel-${blockIdx}-${i}`);
          }
        });

        $tabBtnParent.forEach(parentElm => {
          const $targetBtn = parentElm.querySelectorAll('.js-tabBtn');

          function removeClass(i) {
            $tabItemParent.forEach(contElm => {
              contElm
                .querySelectorAll('.js-tabCont')
                [i].classList.remove('is-active');
              contElm
                .querySelectorAll('.js-tabCont')
                [i].setAttribute('aria-hidden', `true`);
            });
            $targetBtn[i].classList.remove('is-active');
            $targetBtn[i].setAttribute('aria-selected', `false`);
            $targetBtn[i].setAttribute('tabindex', `-1`);
          }

          function addClass($index) {
            $tabItemParent.forEach(contElm => {
              const $conts = contElm.querySelectorAll('.js-tabCont');
              $conts[$index].classList.add('is-active');
              $conts[$index].setAttribute('aria-hidden', 'false');
            });
            $targetBtn[$index].classList.add('is-active');
            $targetBtn[$index].setAttribute('aria-selected', 'true');
            $targetBtn[$index].setAttribute('tabindex', '0');
          }

          function removeAnimationClass(contents) {
            if (contents.classList.contains('sai-animate')) {
              contents.classList.remove('sai-animate');
            }

            const $saiItemList = contents.querySelectorAll('.sai-init');
            $saiItemList.forEach(elm => {
              elm.classList.remove('sai-animate');
            });
          }

          function btnAction(currentIdx, currentParent) {
            removeAnimationClass($tabItem[currentIdx]);
            for (let i = 0, length = $targetBtn.length; i < length; i++) {
              removeClass(i);
            }
            addClass(currentIdx);

            const rect = blockElm.getBoundingClientRect(),
              scrollTop =
                window.pageYOffset || document.documentElement.scrollTop,
              elmTop =
                rect.top +
                scrollTop -
                document.querySelector('.header-gradient').clientHeight /
                  (_breakP.SP ? 2 : 1);

            if (currentParent !== 0) {
              window.scrollTo({
                top: elmTop,
                behavior: 'smooth'
              });
            }

            const $activeCont = blockElm.querySelectorAll(
                '.js-tabCont.is-active'
              ),
              $currentActive = [].slice
                .call($tabItemParent[0].querySelectorAll('.js-tabCont'))
                .indexOf($activeCont[0]),
              $currentActiveCont = $activeCont[$activeCont.length - 1],
              $activeTarget = $currentActiveCont.querySelectorAll(
                'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
              ),
              $currentActiveTarget = $activeTarget[$activeTarget.length - 1];

            const oldListener = $currentActiveTarget._keydownListener;
            if (oldListener) {
              $currentActiveTarget.removeEventListener('keydown', oldListener);
            }

            const newListener = event => {
              if (event.key === 'Tab') {
                if (
                  $currentActive !==
                  $tabItemParent[0].querySelectorAll('.js-tabCont').length - 1
                ) {
                  event.preventDefault();
                  btnAction($currentActive + 1, 0);
                }
              }
            };

            $currentActiveTarget.addEventListener('keydown', newListener);
            $currentActiveTarget._keydownListener = newListener;
          }

          $tabBtn.forEach(btnElm => {
            const $targetParent = btnElm.closest('.js-tabBtnWrap'),
              $target = $targetParent.querySelectorAll('.js-tabBtn'),
              $parentIndex = [].slice
                .call($tabBtnParent)
                .indexOf($targetParent),
              $btnIndex = [].slice.call($target).indexOf(btnElm);

            btnElm.setAttribute(
              'aria-controls',
              `panel-${blockIdx}-${$btnIndex}`
            );

            btnElm.addEventListener('click', event => {
              event.preventDefault();
              btnAction($btnIndex, $parentIndex);
            });

            btnElm.addEventListener('keydown', event => {
              if (event.key === 'Enter' || event.key === ' ') {
                btnAction($btnIndex, $parentIndex);
              }

              if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                event.preventDefault();
                let newIndex;

                if (event.key === 'ArrowRight') {
                  newIndex =
                    $btnIndex + 1 >= $target.length ? 0 : $btnIndex + 1;
                } else {
                  newIndex =
                    $btnIndex - 1 < 0 ? $target.length - 1 : $btnIndex - 1;
                }

                $target[newIndex].focus();
                btnAction(newIndex, $parentIndex);
              }
            });
          });

          const $activeCont = blockElm.querySelectorAll(
              '.js-tabCont.is-active'
            ),
            $currentActive = [].slice
              .call($tabItemParent[0].querySelectorAll('.js-tabCont'))
              .indexOf($activeCont[0]),
            $currentActiveCont = $activeCont[$activeCont.length - 1],
            $activeTarget = $currentActiveCont.querySelectorAll(
              'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
            ),
            $currentActiveTarget = $activeTarget.length
              ? $activeTarget[$activeTarget.length - 1]
              : null;

          if (!$currentActiveTarget) return;
          $currentActiveTarget.addEventListener('keydown', event => {
            if (event.key === 'Tab') {
              event.preventDefault();
              btnAction(
                $currentActive === 0
                  ? $currentActive + 1
                  : $tabItemParent[0].querySelectorAll('.js-tabCont') - 1,
                0
              );
            }
          });
        });
      });
    }
  }
}
